import marked from 'marked';

const renderer = {
  heading: (text, level) => `
    <h${level} class="bp3-heading">
      ${text}
    </h${level}>
  `,
  code: (code, language = '', escaped) => {
    // const runner = `
    //   <div class="bp3-callout code-block-runner-trigger" data-code="${encodeURIComponent(code)}">
    //       <span class="bp3-icon-standard bp3-icon-code" />
    //       <span class="bp3-ui-text">
    //         运行代码
    //       </span>
    //   </div>
    // `;
    const header = `
      <div class="code-header">
        <div>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div>
          <button class="bp3-button bp3-minimal bp3-intent-primary code-block-runner-trigger" data-code="${encodeURIComponent(code)}">
            <span class="bp3-icon-standard bp3-icon-play" />
            <span>运行代码</span>
          </button>
        </div>
      </div>
    `;
    return `
      <div class="bp3-code-container">
        <div class="code-main">
          ${language === 'python' ? header : ''}
          <pre class="bp3-code-block bp3-text-large"><code class="${language}">${code.replace(/</g, '&lt;').replace(/>/g, '&gt;')}</code></pre>
        </div>
      </div>
    `;
  },
  blockquote: (quote) => {
    return `<blockquote class="bp3-blockquote bp3-text-large">${quote}</blockquote>`
  },
  list: (body, ordered, start) => {
    if (ordered) {
      return `<ol start="${start}" class="bp3-list bp3-running-text bp3-text-large">${body}</ol>`
    }
    return `<ul class="bp3-list bp3-running-text bp3-text-large">${body}</ul>`;
  },
  paragraph: (text) => `<div class="bp3-running-text bp3-text-large"><p>${text}</p></div>`,
  table: (header, body) => `
    <table style="width: 100%;box-shadow: inset 0 1px 0 0 hsla(0,0%,100%,.15), inset 1px 0 0 0 hsla(0,0%,100%,.15), 1px 0 0 0 hsla(0,0%,100%,.15), 0 1px 0 0 hsla(0,0%,100%,.15);" class="bp3-html-table bp3-html-table-bordered bp3-text-large">
      <thead>${header}</thead>
      <tbody>${body}</tbody>
    </table>`,
  codespan: (code) => `<code class="bp3-code bp3-text-large">${code}</code>`,
  link: (href, title, text) => `<a href="${href}" title="${title}" target="_blank">${text}</a>`
};
marked.setOptions({
  breaks: true
});
marked.use({ renderer });

export default marked;
